__turbopack_context__.v({
  "expanded": "ShowMoreText-module-scss-module__P-IWAa__expanded",
  "hide": "ShowMoreText-module-scss-module__P-IWAa__hide",
  "lineClamped": "ShowMoreText-module-scss-module__P-IWAa__lineClamped",
  "mobile": "ShowMoreText-module-scss-module__P-IWAa__mobile",
  "moreLessButton": "ShowMoreText-module-scss-module__P-IWAa__moreLessButton",
  "showMoreTextContainer": "ShowMoreText-module-scss-module__P-IWAa__showMoreTextContainer",
  "textContent": "ShowMoreText-module-scss-module__P-IWAa__textContent",
  "widerShowMoreTextContainer": "ShowMoreText-module-scss-module__P-IWAa__widerShowMoreTextContainer",
});
